import { findAll } from "./dom";
import { remote } from "./ajax";
import URI from "urijs";

export default (pending) => {
  findAll(document, ".gk-meta[data-gk-autoload]").forEach((element) => {
    let url = element.getAttribute("data-gk-autoload");
    element.remove();

    if (url.startsWith("#")) {
      const pane = document.querySelector(url);
      url = pane && pane.getAttribute("data-gk-url");
    }

    if (!url) {
      return;
    }

    if (element.getAttribute("data-gk-redirect") === "true") {
      document.location.href = url;
      return;
    }

    if (element.getAttribute("data-gk-push") !== "true") {
      pending.add(URI(url).normalize().resource());
    }

    remote(url);
  });
};
